module.exports = __webpack_public_path__ + "static/img/case3_2.png";